/** Returns true if a trip provides the early booking offer */
export const tripSupportsEarlyBooking = (trip) => { 
  return trip.extraAttributes && trip.extraAttributes.earlyBookingOffer === true;
}

/** Returns true if at least on trip provides the early booking offer */
export const tripsSupportEarlyBooking = trips => trips.some(tripSupportsEarlyBooking);

